var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesDivider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 31,
    viewBox: "0 0 100 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94383 8.66594C7.92047 8.44469 7.63508 8.44469 7.61173 8.66594L7.41596 10.5221C7.16317 12.9189 5.48345 14.8086 3.35299 15.093L1.70308 15.3132C1.50638 15.3395 1.50638 15.6605 1.70308 15.6868L3.35299 15.907C5.48345 16.1914 7.16317 18.0811 7.41596 20.4779L7.61173 22.334C7.63508 22.5553 7.92047 22.5553 7.94383 22.334L8.13959 20.4779C8.39238 18.0811 10.0721 16.1914 12.2026 15.907L13.8525 15.6868C14.0492 15.6605 14.0492 15.3395 13.8525 15.3132L12.2026 15.093C10.0721 14.8086 8.39238 12.9189 8.13959 10.5221L7.94383 8.66594Z",
    fill: "url(#paint0_linear_6946_45445)",
    stroke: "url(#paint1_linear_6946_45445)",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3202 2.32003C50.2752 1.89332 49.7248 1.89332 49.6798 2.32003L49.3022 5.89975C48.8147 10.5221 45.5752 14.1665 41.4665 14.715L38.2845 15.1397C37.9052 15.1904 37.9052 15.8096 38.2845 15.8603L41.4665 16.285C45.5752 16.8335 48.8147 20.4779 49.3022 25.1002L49.6798 28.6799C49.7248 29.1067 50.2752 29.1067 50.3202 28.6799L50.6978 25.1002C51.1853 20.4779 54.4248 16.8335 58.5336 16.285L61.7155 15.8603C62.0948 15.8096 62.0948 15.1904 61.7155 15.1397L58.5336 14.715C54.4248 14.1665 51.1853 10.5221 50.6978 5.89975L50.3202 2.32003Z",
    stroke: "url(#paint2_linear_6946_45445)",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3872 8.66594C92.3638 8.44469 92.0784 8.44469 92.0551 8.66594L91.8593 10.5221C91.6065 12.9189 89.9268 14.8086 87.7963 15.093L86.1464 15.3132C85.9497 15.3395 85.9497 15.6605 86.1464 15.6868L87.7963 15.907C89.9268 16.1914 91.6065 18.0811 91.8593 20.4779L92.0551 22.334C92.0784 22.5553 92.3638 22.5553 92.3872 22.334L92.583 20.4779C92.8357 18.0811 94.5155 16.1914 96.6459 15.907L98.2959 15.6868C98.4925 15.6605 98.4925 15.3395 98.2959 15.3132L96.6459 15.093C94.5155 14.8086 92.8357 12.9189 92.583 10.5221L92.3872 8.66594Z",
    fill: "url(#paint3_linear_6946_45445)",
    stroke: "url(#paint4_linear_6946_45445)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6946_45445",
    x1: 14,
    y1: 15.5,
    x2: 1.55555,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85FAC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6946_45445",
    x1: 14,
    y1: 15.5,
    x2: 1.55555,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85FAC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6946_45445",
    x1: 62,
    y1: 15.5,
    x2: 38,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85FAC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6946_45445",
    x1: 98.4434,
    y1: 15.5,
    x2: 85.9989,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85FAC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6946_45445",
    x1: 98.4434,
    y1: 15.5,
    x2: 85.9989,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85FAC6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesDivider);
export default __webpack_public_path__ + "static/media/featuresDivider.1b9b41c08e07094205efa677d165c1d6.svg";
export { ForwardRef as ReactComponent };